export default __webpack_public_path__ + "static/media/VVS.7001082a.svg";